const igDonationMembership2023Container = document.querySelector('.membership2023')

if (igDonationMembership2023Container) {
  // amount page
  const amountPageMembership2023 = {}
  amountPageMembership2023.amountContainer = igDonationMembership2023Container.querySelector('.amount-suggestions')
  amountPageMembership2023.allAmountInputs = igDonationMembership2023Container.querySelectorAll('.amount-suggestions input[name=amount]')
  amountPageMembership2023.customAmountInput = igDonationMembership2023Container.querySelector('.amount-suggestions input[name=custom-amount]')
  amountPageMembership2023.allRhythmInputs = igDonationMembership2023Container.querySelectorAll('.rhythms input[name=rhythm]')
  amountPageMembership2023.accountHolderField = igDonationMembership2023Container.querySelector('[name=account_holder]')
  amountPageMembership2023.ibanField = igDonationMembership2023Container.querySelector('[name=iban]')
  amountPageMembership2023.bicField = igDonationMembership2023Container.querySelector('[name=bic]')
  amountPageMembership2023.birthdayDayField = igDonationMembership2023Container.querySelector('[name=date_of_birth_day]')
  amountPageMembership2023.birthdayMonthField = igDonationMembership2023Container.querySelector('[name=date_of_birth_month]')
  amountPageMembership2023.birthdayYearField = igDonationMembership2023Container.querySelector('[name=date_of_birth_year]')
  amountPageMembership2023.errorBirthday = igDonationMembership2023Container.querySelector('.error-birthday')
  amountPageMembership2023.errorMinimumamount = igDonationMembership2023Container.querySelector('.error-minamount')
  // personal data page
  const personalDataPage = {}
  personalDataPage.allInputs = window.pages[0].querySelectorAll('input, textarea')
  const accountDataPage = {}
  accountDataPage.allInputs = window.pages[1].querySelectorAll('.input-account')

  // confirmation page
  const confirmationPage = {}
  confirmationPage.donationAmountInput = window.pages[2].querySelector('[name=donation_amount]')
  confirmationPage.donationRhythmInput = window.pages[2].querySelector('[name=donation_rhythm]')
  confirmationPage.allInputs = window.pages[2].querySelectorAll('input, textarea')

  // endpoints/urls
  const fullfillDonationUrl = igDonationMembership2023Container.getAttribute('data-fullfill-donation-endpoint')
  const thankYouUrl = igDonationMembership2023Container.getAttribute('data-thankyou-page')

  // constants
  const loadingHTML = '<div class="spinner-border btn-red" role="status"></div>'

  // minimum amount
  let minimumDonationAmount = 12

  // back button logic
  window.backButton.addEventListener('click', () => {
    window.goToStep(window.currentPage - 1)

    const position = window.getPos(window.pageIndicatorContainer)[1]
    window.scrollToSmoothly(position - 100, 1)
  })

  // next button logic
  window.nextButton.addEventListener('click', async () => {
    let pageIsValid = true
    let errorElement = null

    window.pages[window.currentPage].querySelectorAll('.required, .optional').forEach(
      element => {
        if (!element.classList.contains('is-valid')) {
          if (element.classList.contains('optional')) {
            if (element.value.length) {
              pageIsValid = false
              window.setFieldInvalid(element)
              if (!errorElement) errorElement = element
            }
          } else {
            pageIsValid = false
            window.setFieldInvalid(element)
            if (!errorElement) errorElement = element
          }
        }
      }
    )

    // check for valid Date
    checkValidMemberAge()

    if (pageIsValid) {
      if (window.currentPage === 1) {
        // fill fields on the confirmation page with actual data.
        personalDataPage.allInputs.forEach(input => {
          if (input.value.length) {
            const confirmationElement = window.pages[2].querySelector(
              '[name=' + input.name + ']'
            )

            if (confirmationElement) {
              if (confirmationElement && input.type === 'checkbox' && input.checked === true) {
                confirmationElement.checked = input.checked
                confirmationElement.parentElement.classList.remove('d-none')
              } else {
                confirmationElement.value = input.value
                confirmationElement.parentElement.classList.remove('d-none')
              }
            }
          }
        })
        accountDataPage.allInputs.forEach(input => {
          if (input.value.length) {
            const confirmationElement = window.pages[2].querySelector(
              '[name=' + input.name + ']'
            )

            if (confirmationElement) {
              confirmationElement.value = input.value
              confirmationElement.parentElement.classList.remove('d-none')
            }
          }
        })
        // fill fields on the confirmation page with actual data.
        confirmationPage.donationAmountInput.value = window.getDonationAmount() + ' EURO'
        confirmationPage.donationRhythmInput.value = window.getDonationRhythm(true)
        // hide elements without content on the confirmation page.
        confirmationPage.allInputs.forEach(input => {
          if (!input.value) input.parentElement.classList.add('d-none')
          if (input.type === 'checkbox' && input.checked === false) {
            input.parentElement.classList.add('d-none')
          }
        })
      }

      if (window.currentPage === 2) {
        const donationData = {
          amount: window.getDonationAmount(),
          rhythm: window.getDonationRhythm(false),
          project_id: igDonationMembership2023Container.getAttribute('data-project-id'),
          sepa_account_holder: amountPageMembership2023.accountHolderField.value,
          sepa_iban: amountPageMembership2023.ibanField.value,
          sepa_bic: amountPageMembership2023.bicField.value,
          country: igDonationMembership2023Container.querySelector('[name=country]').value
        }

        personalDataPage.allInputs.forEach(input => {
          if (input.getAttribute('type') === 'checkbox') {
            donationData[input.name] = input.checked
          } else {
            if (input.value) {
              donationData[input.name] = input.value
            }
          }
        })

        window.nextButton.innerHTML = loadingHTML
        window.post(
          response => {
            response = JSON.parse(response)

            if (response.valid === true) {
              window.location = thankYouUrl
            }
          },
          fullfillDonationUrl,
          donationData
        )

        return
      }

      const position = window.getPos(window.pageIndicatorContainer)[1]
      window.scrollToSmoothly(position - 100, 1)

      window.goToStep(window.currentPage + 1)
    } else {
      const position = window.getPos(errorElement)[1]
      window.scrollToSmoothly(position - 100, 1)
    }
  })

  /*******************************************************
   * PAGE 0                                              *
   *******************************************************/

  // dataprotection validation
  igDonationMembership2023Container.querySelector('[name=data_protection_agreement]').addEventListener('change', event => {
    if (event.target.checked) {
      window.setFieldValid(
        event.target.parentElement
      )
    } else {
      window.setFieldInvalid(
        event.target.parentElement
      )
    }
  })

  // commitment to our goals validation
  igDonationMembership2023Container.querySelector('[name=i_commit]').addEventListener('change', event => {
    if (event.target.checked) {
      window.setFieldValid(
        event.target.parentElement
      )
    } else {
      window.setFieldInvalid(
        event.target.parentElement
      )
    }
  })

  // first name
  igDonationMembership2023Container.querySelector('[name=first_name]').addEventListener('change', event => {
    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '2-100'
      }
    )
  })

  // date of birth - added condition because birthday should now displayed as 3 input fields (day, month, year)
  if (document.querySelector('[name=date_of_birth]')) {
    igDonationMembership2023Container.querySelector('[name=date_of_birth]').addEventListener('change', event => {
      window.waitUntilUserHasFinishedTypingAndValidateField(
        event.target,
        {
          type: 'text',
          arguments: '10-10'
        }
      )
    })
  }

  // birthday day
  igDonationMembership2023Container.querySelector('[name=date_of_birth_day]').addEventListener('change', event => {
    if(!checkValidMemberAge()) {
      window.waitUntilUserHasFinishedTypingAndValidateField(
        event.target,
        {
          type: 'int',
          arguments: '1-31'
        }
      )
    }
  })
  // birthday month
  igDonationMembership2023Container.querySelector('[name=date_of_birth_month]').addEventListener('change', event => {
    if(!checkValidMemberAge()) {
      window.waitUntilUserHasFinishedTypingAndValidateField(
        event.target,
        {
          type: 'int',
          arguments: '1-12'
        }
      )
    }
  })
  // birthday month
  igDonationMembership2023Container.querySelector('[name=date_of_birth_year]').addEventListener('change', event => {
    if(!checkValidMemberAge()) {
      const today = new Date();
      // get minimum age
      const atLeast18 = today.getFullYear() - 18
      window.waitUntilUserHasFinishedTypingAndValidateField(
        event.target,
        {
          type: 'int',
          arguments: '1920-' + atLeast18
        }
      )
    }
  })

  // last name
  igDonationMembership2023Container.querySelector('[name=last_name]').addEventListener(
    'change',
    event => {
      window.waitUntilUserHasFinishedTypingAndValidateField(
        event.target,
        {
          type: 'text',
          arguments: '2-100'
        }
      )
    })

  // street
  igDonationMembership2023Container.querySelector('[name=address]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '5-100'
      }
    )
  )

  // postcode
  igDonationMembership2023Container.querySelector('[name=postcode]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '1-100'
      }
    )
  )

  // city
  igDonationMembership2023Container.querySelector('[name=city]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '3-100'
      }
    )
  )

  // phone number
  igDonationMembership2023Container.querySelector('[name=phone].optional').addEventListener(
    'change',
    event => {
      if (event.target.value.length) {
        window.waitUntilUserHasFinishedTypingAndValidateField(
          event.target,
          {
            type: 'phone-number'
          }
        )
      } else {
        window.setFieldValid(event.target)
      }
    }
  )

  // fax
  igDonationMembership2023Container.querySelector('[name=fax].optional').addEventListener(
    'change',
    event => {
      if (event.target.value.length) {
        window.waitUntilUserHasFinishedTypingAndValidateField(
          event.target,
          {
            type: 'phone-number'
          }
        )
      } else {
        window.setFieldValid(event.target)
      }
    }
  )

  // acedemic title
  igDonationMembership2023Container.querySelector('[name=acedemic_title].optional').addEventListener(
    'change',
    event => {
      if (event.target.value.length) {
        window.waitUntilUserHasFinishedTypingAndValidateField(
          event.target,
          {
            type: 'text',
            arguments: '2-50'
          }
        )
      } else {
        window.setFieldValid(event.target)
      }
    }
  )

  // email
  igDonationMembership2023Container.querySelector('[name=email]').addEventListener(
    'change',
    event => window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'email'
      }
    )
  )

  /*******************************************************
   * PAGE 0                                              *
   *******************************************************/

  // amount validation/logic
  amountPageMembership2023.allAmountInputs.forEach(element => {
    element.addEventListener('change', event => {
      amountPageMembership2023.customAmountInput.value = ''

      window.setFieldValid(
        amountPageMembership2023.amountContainer
      )
    })
  })

  amountPageMembership2023.customAmountInput.addEventListener('change', () => {
    amountPageMembership2023.allAmountInputs.forEach(element => { element.checked = false })
    // check minimum Amount
    amountPageMembership2023.allRhythmInputs.forEach(input => {
      if(input.checked === true) {
        minimumDonationAmount = input.getAttribute("data-minimum-amount")
        amountPageMembership2023.errorMinimumamount.innerHTML = minimumDonationAmount
      }
    })
    const currentValue = parseInt(amountPageMembership2023.customAmountInput.value)
    const minamount = parseInt(minimumDonationAmount)
    if (currentValue >= minamount) {
      window.setFieldValid(
        amountPageMembership2023.amountContainer
      )
    } else {
      window.setFieldInvalid(
        amountPageMembership2023.amountContainer
      )
    }
  })

  // rhythm validation/logic
  amountPageMembership2023.allRhythmInputs.forEach(input => {
    input.addEventListener('change', event => {
      const rhythmID = event.target.getAttribute('data-rhythm-key')

      window.setFieldValid(
        event.target.parentElement.parentElement
      )
      // check minimum Amount
      minimumDonationAmount = event.target.getAttribute("data-minimum-amount")
      amountPageMembership2023.errorMinimumamount.innerHTML = minimumDonationAmount
      if(amountPageMembership2023.customAmountInput.value) {
        const currentValue = parseInt(amountPageMembership2023.customAmountInput.value)
        const minamount = parseInt(minimumDonationAmount)

        if (currentValue > 0 && currentValue >= minamount) {
          window.setFieldValid(
            amountPageMembership2023.amountContainer
          )
        } else {
          window.setFieldInvalid(
            amountPageMembership2023.amountContainer
          )
        }
      }
    })
  })

  // payment method validation/logic

  amountPageMembership2023.accountHolderField.classList.add('required')
  amountPageMembership2023.ibanField.classList.add('required')

  amountPageMembership2023.accountHolderField.addEventListener('keyup', event => {
    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'text',
        arguments: '5-100'
      }
    )
  })

  amountPageMembership2023.ibanField.addEventListener('keyup', event => {
    if (event.target.value.substring(0, 2).toUpperCase() === 'DE') {
      amountPageMembership2023.bicField.parentElement.querySelector('label').classList.remove('required-indicator')
      amountPageMembership2023.bicField.classList.remove('validation-error')
      amountPageMembership2023.bicField.classList.remove('required')
    } else {
      amountPageMembership2023.bicField.parentElement.querySelector('label').classList.add('required-indicator')
      amountPageMembership2023.bicField.classList.add('required')
    }

    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'iban'
      }
    )
  })

  amountPageMembership2023.bicField.addEventListener('keyup', event => {
    window.waitUntilUserHasFinishedTypingAndValidateField(
      event.target,
      {
        type: 'bic'
      }
    )
  })

  /**
   * add error message for bithday
   */
  window.checkBirthdayErrors = function () {
    // check if all birthday fields are valid
    const fieldsWithErrors = igDonationMembership2023Container.querySelectorAll('.input-birthday.validation-error')
    if (fieldsWithErrors.length) {
      amountPageMembership2023.errorBirthday.classList.add('error-birthday--visible')
    } else {
      amountPageMembership2023.errorBirthday.classList.remove('error-birthday--visible')
    }
  }

  /**
   * Check if member has entered a valid date and is at least 18 years
   *
   * @returns {boolean}
   */
  var checkValidMemberAge = function checkValidMemberAge() {
    let dayVal = amountPageMembership2023.birthdayDayField.value;
    let monthVal = amountPageMembership2023.birthdayMonthField.value;
    let yearVal = amountPageMembership2023.birthdayYearField.value;
    if (dayVal > 0 && monthVal > 0 && yearVal > 0) {
      if(dayVal.length === 1) {
        dayVal = '0'+dayVal;
      }
      if(monthVal.length === 1) {
        monthVal = '0'+monthVal;
      }
      var birthDate = new Date(yearVal + '-' + monthVal + '-' + dayVal);

      if (Object.prototype.toString.call(birthDate) === "[object Date]") {
        if (isNaN(birthDate)) {
          setBithdayFieldsInvalid();
        } else {
          // it is valid a date
          // check if member is at least 18
          if(getAge(birthDate) < 18) {
            setBithdayFieldsInvalid();
          } else {
            setBithdayFieldsValid();
          }
        }
      } else {
        setBithdayFieldsInvalid();
      }

      return true;
    } else {
      return false;
    }
  };

  function setBithdayFieldsInvalid() {
    igDonationMembership2023Container.querySelectorAll('.input-birthday').forEach(input => {
      window.setFieldInvalid(
        input
      )
    })
  }

  function setBithdayFieldsValid() {
    igDonationMembership2023Container.querySelectorAll('.input-birthday').forEach(input => {
      window.setFieldValid(
        input
      )
    })
  }

  /**
   * Calc current age
   * @param birthDay
   * @returns {number}
   */
  function getAge(birthDay) {
    var today = new Date();
    var birthDate = new Date(birthDay);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
}
